import { doc, getDoc, onSnapshot, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const CONFIG_REF = doc(db, "config", "platform");

const DEFAULT_CONFIG = {
  waitlistOpen: true,
  wordDropEnabled: false,
  numberDropEnabled: false,
};

function normalizeConfig(data) {
  return {
    ...DEFAULT_CONFIG,
    ...(data || {}),
    waitlistOpen: data?.waitlistOpen !== false,
    wordDropEnabled: data?.wordDropEnabled === true,
    numberDropEnabled: data?.numberDropEnabled === true,
  };
}

export async function getPlatformConfig() {
  const snap = await getDoc(CONFIG_REF);
  return normalizeConfig(snap.exists() ? snap.data() : null);
}

export async function setWaitlistOpen(waitlistOpen) {
  await setDoc(
    CONFIG_REF,
    {
      waitlistOpen: Boolean(waitlistOpen),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  return Boolean(waitlistOpen);
}

export function subscribePlatformConfig(onData, onError) {
  return onSnapshot(
    CONFIG_REF,
    (snap) => {
      onData(normalizeConfig(snap.exists() ? snap.data() : null));
    },
    (err) => {
      console.error("Platform config subscribe error:", err);
      onError?.(err);
      onData(DEFAULT_CONFIG);
    }
  );
}
